export const FLOW_NAME = "impact-analysis-continous";
export type FLOW_TYPE = "impact-analysis-continous";

export const INPUT_DATA = "data";

export const Y_COLUMN_KEY = "y";

export const TIME_VARIABLE_KEY = "time";
export const ID_VARIABLES_KEY = "id-vars";
export const TREATMENT_FILTERS_KEY = "treatment-filters";

export const RECIPE =
  "under-what-conditions-is-a-numeric-outcome-higherlower-in-treatment-than-control-and-by-how-much";

export const ALGOS = ["significance-uplift-tree"];

export const RUN_ID = "RUN_ID";
export const INIT_RUN = "INIT_RUN";
export const CREATED_BY = "CREATED_BY";
export const TIME_STAMP = "TIME_STAMP";

export const TREATMENT_TAG = "treatment_tag";
export const CONTROL_TAG = "control_tag";
